import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject, map } from "rxjs";
import { environment } from "src/environments/environment.prod";

@Injectable({
  providedIn: "root",
})
export class SharedService {
  constructor(private httpClient: HttpClient) {}

  private sharedData = new BehaviorSubject({});
  sharedData$ = this.sharedData.asObservable();

  private searchDetails = new BehaviorSubject({});
  currentsearchDetails = this.searchDetails.asObservable();

  private authStateSubject = new BehaviorSubject<any>(null);
  authState$ = this.authStateSubject.asObservable();

  notifyAuthChange(data?: any) {
    this.authStateSubject.next(data || true);
  }

  sendData(data: any) {
    this.sharedData.next(data);
  }

  updateSearchDetails(message: any) {
    this.searchDetails.next(message);
  }
  webPagesGet(webpage_type: any): Observable<any> {
    // let header = new HttpHeaders({
    //   Authorization: "Bearer " + token,
    // });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}webpages/${webpage_type}`,
        {
          // headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
